
//会员等级，会员设置页面接口
import { get, put, putJson} from '../axios2'

const RESOURCE_BASE_PATH = '/member/center/level';


/***
 * 查询会员等级积分设置
 * @param p
 */
export const querymemberLevel= p => get(`${RESOURCE_BASE_PATH}` ,p)

/***
 * 设置自定义会员等级名称
 * @param p
 */
export const setmemberLevel = p => put(`${RESOURCE_BASE_PATH}`, p)

/***
 * 平台版 会员等级管理
 * @param p
 */
export const levelManagement= p => get('member/center/platform/levelManagement' ,p)

